import { render, staticRenderFns } from "./certifications.vue?vue&type=template&id=61af566a&scoped=true"
import script from "./certifications.vue?vue&type=script&lang=js"
export * from "./certifications.vue?vue&type=script&lang=js"
import style0 from "./certifications.vue?vue&type=style&index=0&id=61af566a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61af566a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61af566a')) {
      api.createRecord('61af566a', component.options)
    } else {
      api.reload('61af566a', component.options)
    }
    module.hot.accept("./certifications.vue?vue&type=template&id=61af566a&scoped=true", function () {
      api.rerender('61af566a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/supplier/sections/certifications.vue"
export default component.exports